module.exports = "<test-player [data]=\"testData\"></test-player>\r\n"